import { ComplianceStatus } from '@commenda/prisma';
import { SyntheticComplianceStatus } from '@commenda/types/src/compliance-calendar/compliances/types';
import { NonTimezoneSensitiveDate } from '@commenda/utils';

export function getComplianceStatusName(
  complianceStatus: ComplianceStatus
): string {
  const statusNameMapping: Record<ComplianceStatus, string> = {
    [ComplianceStatus.FILED]: 'Filed',
    [ComplianceStatus.NOT_FILED]: 'Not Filed',
    [ComplianceStatus.REJECTED]: 'Rejected',
    [ComplianceStatus.UNDER_FILING]: 'Under Filing',
    [ComplianceStatus.UNKNOWN]: 'Unknown',
    [ComplianceStatus.COMPLETED]: 'Completed',
    [ComplianceStatus.ARCHIVED]: 'Archived',
    [ComplianceStatus.EXTENDED]: 'Extended',
  };

  return statusNameMapping[complianceStatus];
}

export function getSyntheticComplianceStatusName(
  complianceStatus: SyntheticComplianceStatus
): string {
  const statusNameMapping: Record<SyntheticComplianceStatus, string> = {
    [SyntheticComplianceStatus.FILED]: 'Filed',
    [SyntheticComplianceStatus.NOT_FILED]: 'Not filed',
    [SyntheticComplianceStatus.REJECTED]: 'Rejected',
    [SyntheticComplianceStatus.UNDER_FILING]: 'Under filing',
    [SyntheticComplianceStatus.UNKNOWN]: 'Unknown',
    [SyntheticComplianceStatus.DUE_SOON]: 'Due soon',
    [SyntheticComplianceStatus.UPCOMING]: 'Upcoming',
    [SyntheticComplianceStatus.COMPLETED]: 'Completed',
    [SyntheticComplianceStatus.OVERDUE]: 'Overdue',
    [SyntheticComplianceStatus.ARCHIVED]: 'Archived',
    [SyntheticComplianceStatus.EXTENDED]: 'Extended',
  };

  return statusNameMapping[complianceStatus];
}

export const getComplianceStatus = (
  status: SyntheticComplianceStatus,
  dueDate: string
) => {
  const isOverDue =
    status &&
    NonTimezoneSensitiveDate.fromISO8601String(dueDate).lte(
      NonTimezoneSensitiveDate.fromNativeDate(new Date())
    );

  if (
    isOverDue &&
    status !== SyntheticComplianceStatus.COMPLETED &&
    status !== SyntheticComplianceStatus.FILED
  )
    return 'Overdue';
  if (status === SyntheticComplianceStatus.NOT_FILED) return 'Upcoming';
  return getSyntheticComplianceStatusName(status);
};
